import { CalendarEvent } from './calendar-event.model';

export class EventCalendarAdapter extends CalendarEvent {
  constructor(data: Partial<EventCalendarAdapter> = {}) {
    super(data);
  }
}
